<template>
  <div class="pdf-container row" v-loading="loading">
    <div ref="pdfContainer" class="pdf-viewer"></div>
  </div>
</template>
    
<script>
import api from '@/rest/questionQuery';
import { PDFViewer } from 'web-pdf-viewer';

export default {
  name: 'Pdf',
  props: {
    goToPage: {
      required: false,
      type: Number,
      default: 1
    },
    go: {
      required: false,
      type: Boolean
    },
    link: {
      required: true,
      type: String
    },
    caseNumber: {
      type: String
    }
  },
  data() {
    return {
      pv: null,
      pdfData: null,
      loading: false,
      pdfContainer: null,
      pdfWidth: 800
    };
  },
  watch: {
    go() {
      if (this.pv) {
        this.pv.scrollTo(this.goToPage, 1);
      }
    }
  },
  methods: {
    amplificationPdf() {
      if (this.pdfWidth < 1300) {
        this.pdfWidth += 100;
        this.pv.resize(this.pdfWidth);
        this.pdfContainer.style.width = `${this.pdfWidth}px`;
      }
    },
    shrinkPdf() {
      if (this.pdfWidth > 200) {
        this.pdfWidth -= 100;
        this.pv.resize(this.pdfWidth);
        this.pdfContainer.style.width = `${this.pdfWidth}px`;
      }
    },
    newPdfViewer() {
      if (this.pdfData && !this.pv) {
        this.pv = new PDFViewer({
          cmaps: './cmaps/',
          data: this.pdfData,
          container: this.$refs.pdfContainer,
          isRenderText: true,
          containerBackground: '#ffffff',
          gap: 0
        });
        this.addPdfReadyLinstener();
      } else if (!this.pdfData && !this.pv) {
        this.$message.error('pdf 错误');
      }
    },
    async getPdfData() {
      this.loading = true;
      try {
        const res = await api.getPdfData(this.link);
        this.pdfData = res;
        this.newPdfViewer();
        this.loading = false;
      } catch (err) {
        if (err.response && err.response.msg) {
          this.$message.error(err.response.msg);
        }
        this.loading = false;
      }
    },
    async showPdf() {
      await this.getPdfData();
      this.newPdfViewer();
    },
    addPdfReadyLinstener() {
      if (!this.pv) return;
      this.pv.addEventListener('load', () => {
        this.$emit('pdfInitReady');
      });
    }
  },
  mounted() {
    this.pdfContainer = document.querySelector('.pdf-container');
    this.showPdf();
  },
  beforeDestroy() {
    if (this.pv) {
      this.pv.destroy();
    }
  }
};
</script>
    
<style lang="scss" scoped>
.pdf-container {
  width: 100%;
  height: 100%;
  .pdf-viewer {
    width: 100%;
    height: 100%;
  }
}
</style>
